import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { useState } from "react";

interface ProxyImportFormProps {
  onSubmit: (rawData: string) => void;
}

export function ProxyImportForm(props: ProxyImportFormProps) {
  const [rawData, setRawData] = useState("");

  const canSubmit = rawData.trim().length > 0;

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    props.onSubmit(rawData);
  };

  return (
    <Box>
      <Typography variant="h5" gutterBottom>
        Импорт прокси
      </Typography>

      <form onSubmit={handleSubmit}>
        <TextField
          label="Список прокси"
          value={rawData}
          onChange={(event) => setRawData(event.target.value)}
          multiline
          minRows={8}
          maxRows={20}
          fullWidth
          size="small"
          placeholder="host:port:login:password"
          helperText="По одной записи на строку. Формат: host:port:login:password"
          sx={{ mb: 2 }}
        />

        <Box display="flex" gap={1}>
          <Button
            type="submit"
            variant="contained"
            disabled={!canSubmit}
          >
            Отправить на проверку
          </Button>
        </Box>
      </form>
    </Box>
  );
}
